import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import {
  DocumentoItem,
  UseDocumentosParams,
} from "core/features/documentos/typings";

function useDocumentos(params: UseDocumentosParams) {
  return useQuery([`/v1/documento`, params], async () => {
    const { data } = await http.get<PaginateResult<DocumentoItem>>(
      `/v1/documento`,
      {
        params,
      }
    );

    return data;
  });
}

export default useDocumentos;
